import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';
import annotation from 'chartjs-plugin-annotation';

Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  annotation
);

Chart.defaults.font.family = 'Montserrat';
